import { RxCross2 } from "react-icons/rx";

import { cn } from "@sorcery/ui";

export const CardRemover = ({
  offset,
  onRemove,
}: {
  offset: boolean;
  onRemove: () => void;
}) => (
  <div
    className={cn(
      "bg-secondary absolute z-10 hidden cursor-pointer select-none rounded-full border border-white p-2 opacity-50 transition duration-300 animate-in fade-in hover:opacity-80 group-hover:block",
      offset ? "-left-8 bottom-[4.5rem]" : "bottom-4 left-4",
    )}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onRemove();
    }}
  >
    <RxCross2 size={16} className="text-white" />
  </div>
);
